import request from '@/utils/request';

//课程反馈与评价
export function commentSaveApi(data) {
    return request({
        url: `/system/study/center/student/comment/save`,
        method: 'post',
        data
    })
}

//腾讯鉴权点播
export function getPlayTokenApi(fileId) {
    return request({
        url: `/system/study/center/chapter/getPlayToken/${fileId}`,
        method: 'get'
    })
}

//评价信息
export function getCommentByRequestApi(data) {
    return request({
        url: `/system/study/center/student/comment/getCommentByRequest`,
        method: 'post',
        data
    })
}
//保存观看记录
export function saveVideoLearningApi(data) {
    return request({
        url: `/system/study/center/chapter/saveVideoLearning`,
        method: 'post',
        data
    })
}

//笔记保存
export function noteSaveApi(data) {
    return request({
        url: `/system/study/center/student/note/save`,
        method: 'post',
        data
    })
}

//笔记列表
export function noteListApi(data) {
    return request({
        url: `/system/study/center/student/note/getList`,
        method: 'post',
        data
    })
}